// app_url=https://inorbitcontactmanagement.kraheja.com
// export const AxiosDefaultPort = "https://timesheet.samishti.com:9005/";
// export const AxiosDefaultPort =
//   "https://inorbitcontactmanagement.kraheja.com:9000/";

import AXIOS from "../utils/AXIOS";

// export const AxiosDefaultPort = "https://pdhanewala.com:9001/";
export const AxiosDefaultPort = AXIOS.defaultPort;
